/* eslint-disable react/destructuring-assignment */
import React, { useContext, useEffect, useState } from "react";
import { transactionStatus } from "pages/transactions/constants";
import Button from "pages/_components/Button";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import GridTable from "pages/_components/GridTable/GridTable";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { instanceOf, string, bool, func } from "prop-types";
import { TransactionSign } from "pages/_components/TransactionCard";
import { actions as servicePaymentsActions } from "reducers/servicePayments";
import * as i18n from "util/i18n";
import Image from "pages/_components/Image";
import { useDispatch, useSelector } from "react-redux";
import CustomText from "pages/_components/CustomText/CustomText";

export const ServicePaymentSummaryBody = (props) => {
    const { voucherData, fetching } = useSelector((state) => state.servicePayments);
    const dispatch = useDispatch();
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {}, idTransactionStatus = "" } = transaction;
    const isFinished = idTransactionStatus === transactionStatus.FINISHED;
    const isPending = idTransactionStatus === transactionStatus.PENDING;
    const forTicket = isPending || isFinished;
    const [buttonLabel, setButtonLabel] = useState(
        props.isDesktop ? "echecks.seeMore.button" : "echecks.seeLess.button",
    );

    const handleSeeMoreData = () => {
        props.setShowMoreData(!props.showMoreData);
        if (!props.showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };

    const {
        companyName = props.companyName,
        accountLabel = props.accountLabel,
        amount = props.amount,
        operationId = props.operationId,
        details = props.details,
        transactionNumber = "",
    } = data;

    useEffect(() => {
        if (operationId && props.isTicket && isFinished) {
            props.setVaucherLoading(fetching);
            dispatch(servicePaymentsActions.getVoucherData(operationId));
        }
    }, [operationId]);

    if (forTicket) {
        return (
            <div className="ticket__body refills-transaction">
                <div className="ticket-header-info" style={{ gap: "25px" }}>
                    <CustomData titleText="Empresa" titleTextType="text" valueText={companyName} />
                    <CustomData
                        dataClass={`amount tag ${isFinished ? "tag-echeq-character" : "tag-warning"}`}
                        titleText="payments.service.totalAmount.label"
                        titleTextType="I18N"
                        valueText={
                            <FormattedAmount
                                className="data-label"
                                currency={amount.currency}
                                quantity={amount.quantity}
                            />
                        }
                    />
                </div>
                <div className="view-more-data-button" id="element-to-ignore">
                    <div className="ticket__divider inside-ticket__body">
                        <div className="ticket__notch ticket__notch--left"> </div>
                        <div className="ticket__notch ticket__notch--right"> </div>
                    </div>
                    <Button
                        aria-expanded={props.showMoreData ? "true" : "false"}
                        className="more-button"
                        label={buttonLabel}
                        bsStyle="link"
                        onClick={handleSeeMoreData}
                        image={props.showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                    />
                </div>
                <div className={`view-more-data ${props.showMoreData ? "expand " : "collapse"}`}>
                    <h2>{i18n.get("creditBill.aditionalData.label")}</h2>
                    {isPending && (
                        <>
                            <CustomData
                                titleText="payments.service.paymentId"
                                titleTextType="I18N"
                                valueText={transactionNumber || operationId}
                            />
                            <CustomData
                                titleText="payments.service.debitAccountId.label"
                                titleTextType="I18N"
                                valueText={accountLabel}
                            />
                            {details.map((detail) => (
                                <CustomData
                                    key={`summary-bill-${detail.label}`}
                                    titleText={detail.label}
                                    valueText={detail.value}
                                />
                            ))}
                        </>
                    )}
                    {voucherData.length > 0 && isFinished && (
                        <div className="aditional-data">
                            {voucherData?.map((item) => (
                                <>
                                    <CustomText text={item} className="service-payments-rapi" />
                                    <br />
                                </>
                            ))}
                        </div>
                    )}
                    <TransactionSign
                        noDate
                        creationTime
                        isSmall
                        // hasSignatures
                        isDesktop={props.isDesktop}
                        showMoreData={props.showMoreData}
                    />
                </div>
                {isFinished && (
                    <div className="view-more-data-button">
                        <div className="ticket__divider inside-ticket__body" />
                        <Image src="images/figma/illustrations/rapipago.svg" />
                    </div>
                )}
            </div>
        );
    }

    return (
        <GridTable className="form-summary py-8">
            <GridTable.Container columns={3}>
                <GridTable.Data>
                    <CustomData
                        titleText="payments.service.companyCode.label"
                        titleTextType="I18N"
                        valueText={companyName}
                    />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData titleText="payments.service.paymentId" titleTextType="I18N" valueText={operationId} />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData
                        titleText="payments.service.totalAmount.label"
                        titleTextType="I18N"
                        valueText={
                            <FormattedAmount
                                className="data-label"
                                currency={amount.currency}
                                quantity={amount.quantity}
                            />
                        }
                    />
                </GridTable.Data>
                {details.map((detail) => (
                    <GridTable.Data key={`summary-bill-${detail.label}`}>
                        <CustomData titleText={detail.label} valueText={detail.value} />
                    </GridTable.Data>
                ))}
                <GridTable.Data>
                    <CustomData
                        titleText="payments.service.debitAccountId.label"
                        titleTextType="I18N"
                        valueText={accountLabel}
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );
};

ServicePaymentSummaryBody.propTypes = {
    companyName: string,
    accountLabel: string,
    amount: instanceOf(Object),
    operationId: string,
    details: instanceOf(Array),
    showMoreData: bool.isRequired,
    isDesktop: bool,
    setShowMoreData: func.isRequired,
    isTicket: bool,
    setVaucherLoading: func,
};

ServicePaymentSummaryBody.defaultProps = {
    companyName: "",
    accountLabel: "",
    amount: {
        currency: "",
        quantity: 0,
    },
    operationId: "",
    details: [],
    isDesktop: false,
    isTicket: false,
    setVaucherLoading: () => {},
};

export default ServicePaymentSummaryBody;
